module.exports = __webpack_public_path__ + "media/images/bg/mosaic/ninja-8d87e5300a2dc7b0c78de2e8711f7282.jpg";